import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import CallControl from "features/Header/PuzzelTelephone/components/CallControl/CallControl";
import { Logon } from "features/Header/PuzzelTelephone/components/Logon/Logon";
import { PuzzelProvider } from "features/Header/PuzzelTelephone/provider/PuzzelProvider";

const Puzzel = () => (
  <PuzzelProvider>
    <CallControl />
    <Logon />
  </PuzzelProvider>
);

export default withErrorBoundary(Puzzel);
